export default "__VITE_ASSET__DTBgpK$R__"